import React from 'react';

import LinkTextToAvoidInJobSearchesLoader from './LinkTextToAvoidInJobSearchesLoader';
import Stack from '../../Shared/UI/Stack/components/Stack';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import LinkTextToAvoidInJobSearchesTable from './LinkTextToAvoidInJobSearchesTable';
import AddLinkTextForm from './AddLinkTextForm';
import DeleteLinkTextModal from './DeleteLinkTextModal';

import styles from './LinkTextToAvoidInJobSearches.module.scss';

const LinkTextToAvoidInJobSearches = () => {
  return (
    <>
      <LinkTextToAvoidInJobSearchesLoader />
      <div className={styles.pageLayout}>
        <Stack gap="lg">
          <PageTitle text={'Link Text to Avoid in Job Search'} />
          <AddLinkTextForm />
          <LinkTextToAvoidInJobSearchesTable />
        </Stack>
      </div>
      <DeleteLinkTextModal />
    </>
  );
};

export default LinkTextToAvoidInJobSearches;
